// src/pages/Profile/ui/ActionButton.jsx

import React from "react";
import { cn } from "../utils/profileUtils";

export default function ActionButton({
  children,
  onClick,
  type = "button",
  icon: Icon,
  variant = "primary",
  disabled = false,
  className = "",
}) {
  const variants = {
    primary:
      "bg-primary text-white shadow-lg hover:-translate-y-0.5 hover:brightness-110",
    secondary:
      "border border-slate-200 bg-white text-slate-700 shadow-sm hover:-translate-y-0.5 hover:border-primary/30 hover:text-primary dark:border-white/10 dark:bg-white/5 dark:text-slate-200",
    danger:
      "border border-red-200 bg-red-50 text-red-700 hover:-translate-y-0.5 hover:bg-red-100 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300",
    success:
      "border border-emerald-200 bg-emerald-50 text-emerald-700 hover:-translate-y-0.5 hover:bg-emerald-100 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-bold transition",
        variants[variant] || variants.primary,
        "focus:outline-none focus:ring-4 focus:ring-primary/20",
        disabled &&
          "cursor-not-allowed opacity-60 hover:translate-y-0 hover:brightness-100",
        className
      )}
    >
      {Icon && <Icon className="text-sm" />}
      {children}
    </button>
  );
}